import { AttachmentSmall } from '@app/components/various/Icons';
import { Link } from '@app/components/various/Link';
import { Tooltip } from '@app/components/various/Tooltip';
import { isEmpty } from '@app/utils/isEmpty';
import { Order } from '@typings';
import { useTranslation } from 'react-i18next';

interface Props {
  attachments?: Order.Attachment[];
}

export const CheckoutSuccessAttachments = ({ attachments = [] }: Props) => {
  const { t } = useTranslation(['common', 'checkout']);

  if (isEmpty(attachments)) {
    return null;
  }

  return (
    <div className="box">
      <h3 className="mb-5 heading-3">{t('checkout:attachments')}</h3>
      <div className="grid grid-cols-2 gap-5">
        {attachments.map(({ content, createdAt }, idx) => (
          <div key={idx} className="flex items-center gap-2">
            <div className="flex size-10 flex-shrink-0 items-center justify-center rounded-regular bg-neutral-96">
              <AttachmentSmall className="size-5" />
            </div>
            <div className="flex flex-col overflow-hidden">
              <Tooltip
                content={
                  <>
                    <span>{content.name}</span>
                    <br />
                    {t('common:added')}: {createdAt}
                  </>
                }
              >
                <div className="truncate body-4">{content.name}</div>
              </Tooltip>
              <Link size="medium" to={content.url} target="_blank" className="w-fit">
                {t('common:preview')}
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
